export interface StaffUser {
  _id: string;
  mobileNumber: string;
  firstName: string;
  lastName: string;
  permissions: string[];
  isActive: boolean;
}

export class User {
  _id = undefined;
  firstName = '';
  lastName = '';
  gender = '';
  email = '';
  mobileNumber = '';
  dateOfBirth = '';
  streetNumber = '';
  address = '';
  city = '';
  country = '';
  zipCode = '';
  roles = [];
  isActive = true;
  accessToken = null;
  partnerToken?: string;  // used for API; same as accessToken when set from login
  staffToken?: string;    // only for staff login
  loginType?: 'partner' | 'staff';
  staff?: StaffUser;      // only for staff login
  partnerType = null;
  mustChangePassword?: boolean;
}
